import { useCallback } from 'react';
import prettyMilliseconds from 'pretty-ms';
import { shortDateFormatter } from 'utils/formatDateTime';

const useJobDetails = ({
  runStart: runStartRaw,
  runEnd: runEndRaw,
  cost: costRaw,
  resultsPath,
  createdOn: createdOnRaw,
  startedOn: startedOnRaw,
  device: deviceRaw,
  ...rest
}) => {
  const runStartDate = new Date(runStartRaw);
  const runEndDate = new Date(runEndRaw);
  const createdOnDate = new Date(createdOnRaw);
  const startedOnDate = new Date(startedOnRaw);

  const runStart = shortDateFormatter(runStartRaw);
  const runEnd = shortDateFormatter(runEndRaw);
  const createdOn = shortDateFormatter(createdOnRaw);
  const startedOn = startedOnRaw ? shortDateFormatter(startedOnRaw) : '-';

  const runtimeInMs = (runEndDate.getTime() - runStartDate.getTime()) || 0;
  const runtime = runStartRaw ? prettyMilliseconds(runtimeInMs) : '-';
  const isValidDate = (d) => d instanceof Date && !isNaN(d);

  // eslint-disable-next-line no-nested-ternary
  const queueTimeInMs = isValidDate(startedOnDate) && isValidDate(createdOnDate)
    ? startedOnDate.getTime() - createdOnDate.getTime()
    : isValidDate(runStartDate) && isValidDate(createdOnDate)
      ? runStartDate.getTime() - createdOnDate.getTime()
      : 0;
  // eslint-disable-next-line no-nested-ternary
  const queueTime = queueTimeInMs > 0 ? prettyMilliseconds(queueTimeInMs) : queueTimeInMs === 0 ? 0 : '-';

  const cost = `$${costRaw / 100}`;

  const device = (deviceRaw || '').toUpperCase();

  const jobMetadataUrl = useCallback(() => {
    window.open(`${resultsPath}metadata.json`, '_blank');
  }, [resultsPath]);

  // return useMemo(() => ({
  //   runStart,
  //   runEnd,
  //   runtime,
  //   cost,
  //   jobMetadataUrl,
  //   createdOn,
  //   queueTime,
  //   device,
  //   ...rest,
  // }), [
  //   cost,
  //   jobMetadataUrl,
  //   runStart,
  //   runEnd,
  //   runtime,
  //   createdOn,
  //   queueTime,
  //   device,
  //   ...rest,
  // ]);

  return {
    cost,
    jobMetadataUrl,
    runStart,
    runEnd,
    runtime,
    createdOn,
    startedOn,
    queueTime,
    device,
    runtimeInMs,
    ...rest,
  };
};
export default useJobDetails;
